/**
 * Which video the tour opens for its "video page" and "Studio" steps.
 *
 * The app already polls `/api/jobs` (the same list `/api/library` filters by
 * `hasVideo`), so no extra fetch: prefer the user's own first video when it
 * has rendered, else the newest rendered one. `null` means the app has no
 * video at all — the video-dependent steps are skipped.
 */
export interface VideoCandidate {
  id: string;
  hasVideo: boolean;
  createdAt: number;
}

export function pickTourVideoId(jobs: readonly VideoCandidate[], preferredId: string | null): string | null {
  if (preferredId && jobs.some((j) => j.id === preferredId && j.hasVideo)) return preferredId;
  let best: VideoCandidate | null = null;
  for (const j of jobs) {
    if (!j.hasVideo) continue;
    if (!best || j.createdAt > best.createdAt) best = j;
  }
  return best ? best.id : null;
}
